import React from 'react';

/**
 * Stores previous values for props, state or any other calculated value.
 *
 * https://reactjs.org/docs/hooks-faq.html#how-to-get-the-previous-props-or-state
 * */
export default function usePrevious<T>(value: T): T | undefined {
  const ref = React.useRef<T>(undefined);

  React.useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}
